export default {"src":"/_next/static/media/about.08673051.svg","height":32,"width":32};